import { useState, useContext, useEffect } 	from "react";
import { Card, CardContent, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"

import DashboardContext 	from "../context";
import useFetch 			from "../../../api/api";

import LoadingCard 			from "./LoadingCard";
import config				from "../../../common/Config";
import useAuth 				from "../../../hooks/useAuth";

const AssetSummaryCard = () => {

	const {portfolio}					= useContext(DashboardContext)
	
	const privateFetch 					= useFetch();

	const [assetList, setAssetList]		= useState()
	const [isLoading, setIsLoading]		= useState(true)

	const auth							= useAuth();
	
	const currencyFormat = new Intl.NumberFormat('pt-BR', {
		style : "currency",
		currency : "BRL",
		maximumFractionDigits: 0, 
		minimumFractionDigits: 0, 
	})

	useEffect(() => {
		
		if (portfolio) {
			privateFetch(config.apiUrl +"/api/portfolio/history/byAsset")
			.then((portfolioHistory) => portfolioHistory.json())
			.then((portfolioHistory) => {

				const summarizePortfolio = (pType, pPortfolioHistory) => {

					const filteredPortfolio = portfolio.filter(p => p.assetType === pType)
			
					const totalValue		= portfolio.reduce((acc, p) => acc + parseFloat(p.currentValue), 0) || 0
					const summarizedCost	= filteredPortfolio.reduce((acc, fp) => acc + parseFloat(fp.cost), 0) || 0
					const summarizedValue	= filteredPortfolio.reduce((acc, fp) => acc + parseFloat(fp.currentValue), 0) || 0
					const historicReturn	= (1 - (summarizedCost/summarizedValue)) * 100 || 0
					const share				= (summarizedValue/totalValue) * 100 || 0
			
					const lastEntry			= pPortfolioHistory.filter(d => d.assetType === pType)
					const todayVariation	= (1-(lastEntry[lastEntry.length-1]?.total/summarizedValue)) * 100 || 0

					return ({
						assetType 		: pType,
						cost			: summarizedCost,
						currentValue	: summarizedValue,
						return			: historicReturn.toFixed(2),
						todayVariation	: todayVariation.toFixed(2),
						share			: share.toFixed(2)
					})
				}

				let summarizedPortfolio = []
			
				summarizedPortfolio.push(summarizePortfolio('ACAO',portfolioHistory))
				summarizedPortfolio.push(summarizePortfolio('STOCK', portfolioHistory))

				if (auth.auth.userId < 50) {
					summarizedPortfolio.push(summarizePortfolio('FII', portfolioHistory))
					summarizedPortfolio.push(summarizePortfolio('BOND', portfolioHistory))
					summarizedPortfolio.push(summarizePortfolio('TESOURODIRETO', portfolioHistory))
					summarizedPortfolio.push(summarizePortfolio('CASH', portfolioHistory))
				}
	
				setAssetList(summarizedPortfolio)
				setIsLoading(false)				
			})		

		}	
	}, [portfolio])

	if (isLoading) {
		return (
			<LoadingCard/>
		)
	}

	return (
		<Card sx={{height: '100%'}}>
			<CardContent>
				<Typography variant="h6" align="center"> Posição por Tipo </Typography>
				<Stack direction={'column'} spacing={1}>
					<TableContainer component={Paper}>
						<Table size="small">
							<TableHead >
								<TableRow>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}}> Tipo </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="left"> Original </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="left"> Atual </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> % Geral </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> % Hoje </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700', display: { xs: 'none', sm: 'table-cell' }}} align="center">  % Portfolio </TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{assetList ? assetList.map((a) => (
									<TableRow key={"key_"+ a.assetType}>
										<TableCell sx={{ fontSize: '0.65rem'}}>{a.assetType}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="left">{currencyFormat.format(a.cost)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="left">{currencyFormat.format(a.currentValue)}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem', color: (a.return >= 0 ? "green" : "red")}} align="center">{a.return}%</TableCell>
										<TableCell sx={{ fontSize: '0.65rem', color: (a.todayVariation >= 0 ? "green" : "red")}} align="center">{a.todayVariation}%</TableCell>
										<TableCell sx={{ fontSize: '0.65rem', display: { xs: 'none', sm: 'table-cell' }}} align="center">{a.share}%</TableCell>
									</TableRow>
								)) : null}
							</TableBody>

						</Table>
					</TableContainer>
				</Stack>
			</CardContent>
		</Card>
	)
}

export default AssetSummaryCard